import React, { useState } from 'react';
import { Autocomplete } from '@react-google-maps/api';
import Input from './styled/Input';
import AutocompleteStyle from './styled/AutocompleteStyle';

const AddressAutocomplete = ({ value, onChange, isTabletOrDesktop }) => {
  const [autocomplete, setAutocomplete] = useState(null);

  const onLoad = (autoC) => setAutocomplete(autoC);

  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      const address = place.formatted_address;
      onChange({
        target: {
          name: 'address',
          value: address,
        },
      });
    } else {
      console.log('Autocomplete is not loaded yet!');
    }
  };

  return (
    <>
      <AutocompleteStyle />
    <Autocomplete
      onLoad={onLoad}
      onPlaceChanged={onPlaceChanged}
      options={{
        types: ['address'],
      }}
    >
      <Input
        as="input"
        type="text"
          width={isTabletOrDesktop ? '416px' : '288px'}
          margin="0"
        name="address"
        placeholder="Address"
        value={value}
        onChange={onChange}
        tabIndex={10}
        maxLength={200}
      />
    </Autocomplete>
    </>
  );
};

export default AddressAutocomplete;